import PlusLandingPage from './PlusLandingPage';

export default PlusLandingPage;
